import * as React from 'react'

import { Stack, Skeleton } from '@mui/material'

import { usePathProgress, usePath } from 'components/hooks/state'
import TrackCard from 'components/atomic/organisms/syllabus/components/track-item'

const PathSyllabusLoading = () => {
    return (
        <Stack spacing="1rem">
            <Skeleton variant="rounded" width={'20%'} height="2rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
        </Stack>
    )
}

interface PathSyllabusProps {
    pathId: string
}

const PathSyllabus = ({ pathId }: PathSyllabusProps) => {
    const { data: pathProgress, loading: loadingProgress } = usePathProgress({ pathId })
    const { data: path, loading: loadingPath } = usePath({ pathId })

    const colors = React.useMemo(() => ['#D4E867', '#E86767', '#67E8D1', '#D667E8', '#679BE8'], [])
    const color = React.useCallback((index: number) => colors[index % colors.length], [colors])

    if (loadingPath || loadingProgress) return <PathSyllabusLoading />

    if (!path) return null

    return (
        <div>
            {path.tracks.map((track, index) => {
                return (
                    <TrackCard
                        pathProgress={pathProgress}
                        pathId={pathId}
                        track={track}
                        key={track._id}
                        color={color(index)}
                    />
                )
            })}
        </div>
    )
}

export default PathSyllabus
